import { BannerType } from "./banner-type.enum";

export class Banner {
  id: string;
  type: BannerType;
  message: string;
  isDismissible: boolean;

  constructor(options: Partial<Banner> = {}) {
    this.id = options.id;
    this.type = options.type || BannerType.Info;
    this.message = options.message || "";
    this.isDismissible = options.isDismissible !== false;
  }
}
